import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { enableMouseControls } from 'store/app/actions';

const mapDispatchToProps = { enableMouseControls };

function WithMouseControls(WrappedComponent) {
  const WithMouseControls = props => {
    useEffect(() => {
      const { enableMouseControls } = props;

      enableMouseControls(true);
      return () => enableMouseControls(false);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return <WrappedComponent {...props} />;
  };

  return connect(
    null,
    mapDispatchToProps,
  )(WithMouseControls);
}

export default WithMouseControls;
